// extracted by mini-css-extract-plugin
export var hidden = "_rt-0";